import { forwardRef as i, useContext as n } from "react";
import { UIKitContext as r } from "../../context/uiKitContext.js";
const f = i((o, e) => {
  const t = n(r);
  if (!t)
    throw Error("Cannot use GenericLink outside of UIKitContext");
  return t.genericLink(o, e);
});
f.displayName = "UIKitLink";
export {
  f as UIKitLink
};
